'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$0024100 from "./presto.types$$anon$100.js";
import * as $j_presto$002etypes$0024$0024anon$002496 from "./presto.types$$anon$96.js";
import * as $j_presto$002etypes$0024$0024anon$002498 from "./presto.types$$anon$98.js";
import * as $j_presto$002etypes$0024$002dTime$002dRange$0024 from "./presto.types$-Time-Range$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$95() {
  this.c2D = null;
  this.c2v = null;
  this.c2w = false;
  this.c2E = null;
  this.c2F = false;
  this.c2I = null;
  this.c2B = null;
  this.c2C = false;
  this.c2x = null;
  this.c2y = false;
  this.c2z = null;
  this.c2A = false;
  this.c2G = false;
  this.c2H = false;
  this.c2D = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c2I = "TimeRange";
}
export { $c_Lpresto_types$$anon$95 as $c_Lpresto_types$$anon$95 };
$p = $c_Lpresto_types$$anon$95.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$95;
/** @constructor */
function $h_Lpresto_types$$anon$95() {
}
export { $h_Lpresto_types$$anon$95 as $h_Lpresto_types$$anon$95 };
$h_Lpresto_types$$anon$95.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.c2D;
});
$p.M = (function() {
  if ((!this.c2w)) {
    this.c2v = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c2w = true;
  }
  return this.c2v;
});
$p.O = (function() {
  if ((!this.c2F)) {
    this.c2E = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c2F = true;
  }
  return this.c2E;
});
$p.E = (function() {
  return this.c2I;
});
$p.t = (function() {
  if ((!this.c2C)) {
    this.c2B = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("starts", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ends", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.c2C = true;
  }
  return this.c2B;
});
$p.N = (function() {
  if ((!this.c2y)) {
    this.c2x = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002etypes$0024$0024anon$002496.$c_Lpresto_types$$anon$96(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002etypes$0024$0024anon$002498.$c_Lpresto_types$$anon$98(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.c2y = true;
  }
  return this.c2x;
});
$p.Q = (function() {
  if ((!this.c2A)) {
    this.c2z = new $j_presto$002etypes$0024$0024anon$0024100.$c_Lpresto_types$$anon$100();
    this.c2A = true;
  }
  return this.c2z;
});
$p.v = (function() {
  if ((!this.c2H)) {
    this.c2G = false;
    this.c2H = true;
  }
  return this.c2G;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee144) => ((p) => \u03b4scrutinee144.cG2(p)))($j_presto$002etypes$0024$002dTime$002dRange$0024.$m_Lpresto_types$TimeRange$())));
});
var $d_Lpresto_types$$anon$95 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$95, "presto.types$$anon$95", ({
  YF: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$95 as $d_Lpresto_types$$anon$95 };
//# sourceMappingURL=presto.types$$anon$95.js.map
